import ActivityInput from "@/pages/(app)/returns/view/components/return-activity/activity-input";
import ActivityList from "@/pages/(app)/returns/view/components/return-activity/activity-list";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Label } from "@babackapp/ui/components/label";
import { ActivityDeactivateAutoTreatLogistician } from "@/pages/(app)/returns/view/components/return-activity/activity-deactivate-auto-treat-logistician.tsx";

type ReturnRequestActivityProps = {
  returnRequest: ReturnRequestDto;
};

export default function Activity({
  returnRequest,
}: ReturnRequestActivityProps) {
  const t = useTranslation();

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-4">
        <Label className="flex-1">{t("returnDetail.activity")}</Label>
        <ActivityDeactivateAutoTreatLogistician returnRequest={returnRequest} />
      </div>
      <div className={"mt-2 flex flex-col gap-2"}>
        <ActivityInput
          returnRequestId={returnRequest.id}
          shopId={returnRequest.shopId}
        />
        <ActivityList
          activities={returnRequest.logs}
          returnRequestId={returnRequest.id}
        />
      </div>
    </div>
  );
}
